import { NetworkConsts } from "./constants";

export class AuthError extends Error {
  constructor(message) {
    super(message);
    this.name = NetworkConsts.AUTHENTICATION_FAILED_NAME;
  }
}
